var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUser = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66667 17.1302V18.3333H18.3333V17.1302C18.3333 16.0226 17.4931 15.125 15.8125 14.4375C14.1319 13.7118 12.5278 13.349 11 13.349C9.47222 13.349 7.86806 13.7118 6.1875 14.4375C4.50694 15.125 3.66667 16.0226 3.66667 17.1302ZM13.5781 9.91146C14.3038 9.18576 14.6667 8.32639 14.6667 7.33333C14.6667 6.34028 14.3038 5.4809 13.5781 4.75521C12.8524 4.02951 11.9931 3.66667 11 3.66667C10.0069 3.66667 9.14757 4.02951 8.42188 4.75521C7.69618 5.4809 7.33333 6.34028 7.33333 7.33333C7.33333 8.32639 7.69618 9.18576 8.42188 9.91146C9.14757 10.6372 10.0069 11 11 11C11.9931 11 12.8524 10.6372 13.5781 9.91146ZM0 2.46354C0 1.77604 0.229167 1.20312 0.6875 0.744792C1.18403 0.248264 1.77604 0 2.46354 0H19.5365C20.1858 0 20.7587 0.248264 21.2552 0.744792C21.7517 1.24132 22 1.81424 22 2.46354V19.5365C22 20.1858 21.7517 20.7587 21.2552 21.2552C20.7587 21.7517 20.1858 22 19.5365 22H2.46354C1.77604 22 1.18403 21.7708 0.6875 21.3125C0.229167 20.816 0 20.224 0 19.5365V2.46354Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/user.69d0ccfe.svg";
export { ForwardRef as ReactComponent };